import { render, staticRenderFns } from "./MultipleForm.vue?vue&type=template&id=73792c60&scoped=true&"
import script from "./MultipleForm.vue?vue&type=script&lang=js&"
export * from "./MultipleForm.vue?vue&type=script&lang=js&"
import style0 from "./MultipleForm.vue?vue&type=style&index=0&id=73792c60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73792c60",
  null
  
)

export default component.exports